import { motion } from "framer-motion";
import { BedDouble, Maximize } from "lucide-react";

export default function PropertyCard({ property, onClick, testid, className = "" }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.97 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      onClick={onClick}
      data-testid={testid || `property-card-${property.id}`}
      className={`group w-[320px] shrink-0 cursor-pointer snap-start sm:w-[440px] ${className}`}
    >
      <div className="relative h-64 overflow-hidden rounded-2xl sm:h-80">
        <img
          src={property.image}
          alt={property.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/50 via-transparent to-transparent" />
        <img
          src="/kemelia-logo-square.png"
          alt="Kemelia Estate"
          className="absolute right-3 top-3 h-11 w-11 rounded-lg border border-gold/40 object-cover shadow-[0_4px_14px_rgba(0,0,0,0.35)]"
        />
        {property.tags?.[0] && (
          <span className="absolute left-4 top-4 rounded-full bg-white/85 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-azur backdrop-blur">
            {property.tags[0]}
          </span>
        )}
        <span className="absolute bottom-4 left-4 font-serif text-2xl font-semibold text-white">
          {property.price}
        </span>
      </div>
      <div className="mt-4 px-1">
        <span className="font-mono text-sm font-medium uppercase tracking-[0.18em] text-terracotta">
          {property.type} — {property.location}
        </span>
        <h3 className="mt-2 font-serif text-2xl font-semibold leading-snug text-azur transition-colors duration-300 group-hover:text-terracotta sm:text-[1.7rem]">
          {property.title}
        </h3>
        <div className="mt-3 flex items-center gap-5 border-t border-slate-200/80 pt-3 text-base font-medium text-azur">
          <span className="flex items-center gap-2">
            <BedDouble size={18} className="text-gold" />
            {property.bedrooms} chambres
          </span>
          <span className="flex items-center gap-2">
            <Maximize size={17} className="text-gold" />
            {property.surface}
          </span>
        </div>
      </div>
    </motion.article>
  );
}
